import * as React from 'react';
import * as firebase from 'firebase' ; 
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
// import { SecurityData } from '../shared/index';
import {   uiConfig } from 'src/base/FirebaseInit';
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
export interface LoginPanelSimpleUsernameProps extends BaseComponentProps {
    firebaseApp: firebase.app.App ; 
    // userLoginDoneHandler: (user: SecurityData.ApplicationUser) => any;
}
export interface LoginPanelSimpleUsernameState extends BaseComponentState {
    username: string | any;
    password: string | any;
    err: boolean;
    errMessage: string;
}

/**
 * panel untuk proses login dengan username + password standard
 */
export class LoginPanelSimpleUsername extends BaseComponent<LoginPanelSimpleUsernameProps, LoginPanelSimpleUsernameState> {
    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = [];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ["err"];
    /**
     * 
     */
    firebaseAuth: any ; 
    constructor(props: LoginPanelSimpleUsernameProps) {
        super(props);
        this.firebaseAuth = this.props.firebaseApp.auth() ; 
        this.state = {
            username: null,
            password: null,
            err: false,
            errMessage: ""
        };
    }

    shouldComponentUpdate(nextProps: LoginPanelSimpleUsernameProps, nextState: LoginPanelSimpleUsernameState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(LoginPanelSimpleUsername.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(LoginPanelSimpleUsername.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    }
    /**
     * handler dengan login dengan username + password standard
     */
    formLoginSimpleSubmitHandler: (evt: React.FormEvent<any>) => any = (evt: React.FormEvent<any>) => {
        evt.preventDefault();
       
        if ( this.firebaseAuth ) {
            const emailComp: any = document.getElementById("email");
            const email = emailComp.value;
            const passComp: any = document.getElementById("pass");
            const pass = passComp.value;
            const signup = this.firebaseAuth.signInWithEmailAndPassword(email, pass);
            signup.catch(
                (err: any) => {
                    console.log(err);
                    this.setStateHelper(
                        st => {
                            st.err = true;
                            st.errMessage = err.message;
                        }
                    );
                }
            );
        } else {
            console.warn(`Auth data is null. please check this use case`) ; 
        }
        
    }

    render(): JSX.Element {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let errPanel = <span />;
        if (this.state.err) {
            errPanel = (
                <div className="alert alert-danger">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    {this.state.errMessage}
                </div>
            );
        }
        console.log(this.state);
        return (
            <form role="form" style={{ minWidth: 300 }}>
             {errPanel}
                <div className="form-group">
                    <label>
                        Email address
                        </label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        required={true}
                        id="email"
                        onChange={evt => {
                            let val: string = evt.target.value;
                            this.setStateHelper(st => st.username = val);
                        }}
                    />
                </div>
                <div className="form-group">
                    <label>
                        Password
                        </label>
                    <input
                        type="password"
                        id="pass"
                        className="form-control"
                        placeholder="Password"
                        required={true}
                        onChange={evt => {
                            let val: string = evt.target.value;
                            this.setStateHelper(st => st.password = val);
                        }}
                    />
                </div>
                <div className="checkbox clip-check check-primary">
                    <input type="checkbox" id="checkbox1" value="1" />
                    <label>  Remember me  </label>
                </div>
                <button type="button" onClick={(e: any) => this.formLoginSimpleSubmitHandler(e)} className="btn form-control btn-primary"> Sign In </button>
                <hr />
                <StyledFirebaseAuth
                    uiConfig={uiConfig}
                    firebaseAuth={this.firebaseAuth}
                />
            </form>
        );
    }

}


// WEBPACK FOOTER //
// ./src/header/LoginPanelSimpleUsername.tsx